(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4997,8337],{

/***/ 69436:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)([/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2M7.35 18.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5s-3.34-.56-4.65-1.5m10.79-1.38C16.45 15.8 14.32 15 12 15s-4.45.8-6.14 2.12C4.7 15.73 4 13.95 4 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.95-.7 3.73-1.86 5.12"
}, "0"), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12 6c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6m0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11"
}, "1")], 'AccountCircleOutlined');

/***/ }),

/***/ 11048:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17 15h2V7c0-1.1-.9-2-2-2H9v2h8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2z"
}), 'Crop');

/***/ }),

/***/ 54048:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), 'OpenInNew');

/***/ }),

/***/ 58822:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'SearchOutlined');

/***/ }),

/***/ 70861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FT": function() { return /* binding */ useButtonProps; }
/* harmony export */ });
/* unused harmony export isTrivialHref */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
const _excluded = ["as", "disabled"];
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }


function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
function useButtonProps({
  tagName,
  disabled,
  href,
  target,
  rel,
  role,
  onClick,
  tabIndex = 0,
  type
}) {
  if (!tagName) {
    if (href != null || target != null || rel != null) {
      tagName = 'a';
    } else {
      tagName = 'button';
    }
  }
  const meta = {
    tagName
  };
  if (tagName === 'button') {
    return [{
      type: type || 'button',
      disabled
    }, meta];
  }
  const handleClick = event => {
    if (disabled || tagName === 'a' && isTrivialHref(href)) {
      event.preventDefault();
    }
    if (disabled) {
      event.stopPropagation();
      return;
    }
    onClick == null ? void 0 : onClick(event);
  };
  const handleKeyDown = event => {
    if (event.key === ' ') {
      event.preventDefault();
      handleClick(event);
    }
  };
  if (tagName === 'a') {
    // Ensure there's a href so Enter can trigger anchor button.
    href || (href = '#');
    if (disabled) {
      href = undefined;
    }
  }
  return [{
    role: role != null ? role : 'button',
    // explicitly undefined so that it overrides the props disabled in a spread
    // e.g. <Tag {...props} {...hookProps} />
    disabled: undefined,
    tabIndex: disabled ? undefined : tabIndex,
    href,
    target: tagName === 'a' ? target : undefined,
    'aria-disabled': !disabled ? undefined : disabled,
    rel: tagName === 'a' ? rel : undefined,
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, meta];
}
const Button = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_ref, ref) => {
  let {
      as: asProp,
      disabled
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [buttonProps, {
    tagName: Component
  }] = useButtonProps(Object.assign({
    tagName: asProp,
    disabled
  }, props));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Component, Object.assign({}, props, buttonProps, {
    ref: ref
  }));
});
Button.displayName = 'Button';
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (Button)));

/***/ }),

/***/ 47893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */
function useCommittedRef(value) {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(value);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref;
}
/* harmony default export */ __webpack_exports__["Z"] = (useCommittedRef);

/***/ }),

/***/ 67177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useCommittedRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47893);


function useEventCallback(fn) {
  const ref = (0,_useCommittedRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(fn);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (...args) {
    return ref.current && ref.current(...args);
  }, [ref]);
}

/***/ }),

/***/ 19085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const isReactNative = typeof __webpack_require__.g !== 'undefined' &&
// @ts-ignore
__webpack_require__.g.navigator &&
// @ts-ignore
__webpack_require__.g.navigator.product === 'ReactNative';
const isDOM = typeof document !== 'undefined';

/**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */
/* harmony default export */ __webpack_exports__["Z"] = (isDOM || isReactNative ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect);

/***/ }),

/***/ 61218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMounted; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Track whether a component is current mounted. Generally less preferable than
 * properlly canceling effects so they don't run after a component is unmounted,
 * but helpful in cases where that isn't feasible, such as a `Promise` resolution.
 *
 * @returns a function that returns the current isMounted state of the component
 *
 * ```ts
 * const [data, setData] = useState(null)
 * const isMounted = useMounted()
 *
 * useEffect(() => {
 *   fetchdata().then((newData) => {
 *      if (isMounted()) {
 *        setData(newData);
 *      }
 *   })
 * })
 * ```
 */
function useMounted() {
  const mounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
  const isMounted = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(() => mounted.current);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return isMounted.current;
}

/***/ }),

/***/ 69802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePrevious; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * Store the last of some value. Tracked via a `Ref` only updating it
 * after the component renders.
 *
 * Helpful if you need to compare a prop value to it's previous value during render.
 *
 * ```ts
 * function Component(props) {
 *   const lastProps = usePrevious(props)
 *
 *   if (lastProps.foo !== props.foo)
 *     resetValueFromProps(props.foo)
 * }
 * ```
 *
 * @param value the value to track
 */
function usePrevious(value) {
  const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    ref.current = value;
  });
  return ref.current;
}

/***/ }),

/***/ 21766:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/logo-depotium.581cb8df.svg","height":220,"width":620});

/***/ }),

/***/ 65100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ my_account_modal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Button.js
var Button = __webpack_require__(70861);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Button.js
"use client";






const Button_Button = /*#__PURE__*/react.forwardRef(({
  as,
  bsPrefix,
  variant = 'primary',
  size,
  active = false,
  disabled = false,
  className,
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'btn');
  const [buttonProps, {
    tagName
  }] = (0,Button/* useButtonProps */.FT)({
    tagName: as,
    disabled,
    ...props
  });
  const Component = tagName;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ...buttonProps,
    ...props,
    ref: ref,
    disabled: disabled,
    className: classnames_default()(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
  });
});
Button_Button.displayName = 'Button';
/* harmony default export */ var esm_Button = (Button_Button);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 36 modules
var Modal = __webpack_require__(61909);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/services/my-account/index.ts
var my_account = __webpack_require__(42169);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
;// CONCATENATED MODULE: ./src/components/header/right-panel-menu/my-account-modal.tsx










var MyAccountModal = function(props) {
    var locale = (0,router.useRouter)().locale;
    var ref = (0,react.useState)([]), storeList = ref[0], setStoreList = ref[1];
    var ref1 = (0,react.useState)(constants/* DEFAULT_SITE_LINK */.qP), siteLink = ref1[0], setSiteLink = ref1[1];
    var ref2 = (0,react.useState)([]), provinceList = ref2[0], setProvinceList = ref2[1];
    var ref3 = (0,react.useState)([]), facilityList = ref3[0], setProvinceFacility = ref3[1];
    var onClose = props.onClose, open = props.open;
    var ref4 = (0,react.useState)("Ontario - GTA"), province = ref4[0], setProvince = ref4[1];
    var ref5 = (0,react.useState)("Quebec"), store = ref5[0], setStore = ref5[1];
    var filterFacility = function(data, facilitySlug) {
        var ref, ref1, ref2;
        var filterFac = (ref = data.find(function(element) {
            var ref;
            return (element === null || element === void 0 ? void 0 : (ref = element.attributes) === null || ref === void 0 ? void 0 : ref.Name) === facilitySlug;
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Facilities) === null || ref2 === void 0 ? void 0 : ref2.data;
        return filterFac;
    };
    var getProvinceData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, brand, provinceListD, provinceData, prov, provS;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        brand = constants/* BRAND_NAME_EN */.Vp;
                        if (locale === "fr") brand = constants/* BRAND_NAME_FR */.Fj;
                        return [
                            4,
                            (0,my_account/* getAllProvincesData */.E)(locale, brand)
                        ];
                    case 1:
                        provinceListD = _state.sent();
                        return [
                            4,
                            provinceListD === null || provinceListD === void 0 ? void 0 : (ref = provinceListD.data) === null || ref === void 0 ? void 0 : ref.data
                        ];
                    case 2:
                        provinceData = _state.sent() || null;
                        setProvinceFacility(provinceData);
                        filterFacility(provinceData, "Quebec");
                        setStoreList(filterFacility(provinceData, "Quebec"));
                        prov = [];
                        provinceData.forEach(function(element) {
                            var ref;
                            prov.push(element === null || element === void 0 ? void 0 : (ref = element.attributes) === null || ref === void 0 ? void 0 : ref.Name);
                        });
                        setProvinceList(prov);
                        provS = [];
                        provinceData.forEach(function(element) {
                            var ref;
                            provS.push(element === null || element === void 0 ? void 0 : (ref = element.attributes) === null || ref === void 0 ? void 0 : ref.Slug);
                        });
                        setStore(prov[0]);
                        return [
                            2
                        ];
                }
            });
        });
        return function getProvinceData() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleStore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref, ref1, currentprovince;
            return (0,tslib_es6.__generator)(this, function(_state) {
                setStoreList([]);
                if (e && e.target) setProvince(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                currentprovince = e === null || e === void 0 ? void 0 : (ref1 = e.target) === null || ref1 === void 0 ? void 0 : ref1.value;
                setStoreList(filterFacility(facilityList, currentprovince));
                return [
                    2
                ];
            });
        });
        return function handleStore(e) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getProvinceData();
        handleStore(undefined);
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (storeList === null || storeList === void 0 ? void 0 : storeList.length) setSiteLink(((ref = storeList[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.Sitelink_URL_ID) || constants/* DEFAULT_SITE_LINK */.qP);
    }, [
        storeList
    ]);
    var handleCloseClick = function() {
        return onClose();
    };
    var getSiteLink = function(e, data) {
        if (e && e.target) {
            var ref, ref1;
            var item = data.filter(function(val) {
                var ref, ref1, ref2;
                return "".concat(val === null || val === void 0 ? void 0 : (ref = val.attributes) === null || ref === void 0 ? void 0 : ref.Title, " - ").concat(val === null || val === void 0 ? void 0 : (ref1 = val.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Address) === null || ref2 === void 0 ? void 0 : ref2.Street_1) === e.target.value;
            });
            setSiteLink(((ref = item[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.Sitelink_URL_ID) || constants/* DEFAULT_SITE_LINK */.qP);
        }
    };
    var handleSubmit = function() {
        window.open("".concat(constants/* SITE_LINK */.Ms, "sCorpCode=ilv2Y31A9yHEzplusa5/gLLlA==&sLocationCode=").concat(siteLink, "==&1=1"), "_blank");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        show: open,
        animation: false,
        id: "myAccountModal",
        onHide: handleCloseClick,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "modal-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        className: "modal-title",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "my-account-heading"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: "border-0 bg-transparent text-white",
                        onClick: handleCloseClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "16",
                            height: "16",
                            fill: "currentColor",
                            className: "bi bi-x-circle-fill",
                            viewBox: "0 0 16 16",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-body",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "my-account-subheading"
                                    }),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "fieldSet provinceField",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "form-label",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "my-account-province"
                                            }),
                                            ":"
                                        ]
                                    }, "provinceSelect"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                        className: "form-select provinceSelect",
                                        onChange: handleStore,
                                        defaultValue: province,
                                        children: provinceList.length ? provinceList.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                defaultValue: item,
                                                children: item
                                            }, item);
                                        }) : ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "fieldSet facilityField",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "form-label",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "my-account-store"
                                            }),
                                            ":"
                                        ]
                                    }, "storeSelect"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                        className: "form-select storeSelect",
                                        "aria-label": " Select Store",
                                        onChange: function(e) {
                                            return getSiteLink(e, storeList);
                                        },
                                        defaultValue: store,
                                        children: (storeList === null || storeList === void 0 ? void 0 : storeList.length) ? storeList.map(function(item) {
                                            var ref, ref1, ref2, ref3;
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("option", {
                                                defaultValue: item,
                                                children: [
                                                    item === null || item === void 0 ? void 0 : (ref = item.attributes) === null || ref === void 0 ? void 0 : ref.Title,
                                                    " -",
                                                    " ",
                                                    item === null || item === void 0 ? void 0 : (ref1 = item.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Address) === null || ref2 === void 0 ? void 0 : ref2.Street_1
                                                ]
                                            }, item === null || item === void 0 ? void 0 : (ref3 = item.attributes) === null || ref3 === void 0 ? void 0 : ref3.Title);
                                        }) : ""
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_Button, {
                                className: "btn dp-primary-btn verify w-100 mt-3",
                                onClick: handleSubmit,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "my-account-button"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var my_account_modal = (MyAccountModal);


/***/ }),

/***/ 18228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loadInvender */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var loadInvender = function(invendrKey, pageKey) {
    var script = document === null || document === void 0 ? void 0 : document.createElement("script");
    if (script && invendrKey && invendrKey !== window.location.pathname) {
        script.src = "https://dev-invendr-dni.devv.ca/api/script/".concat(invendrKey, ".js?callback=get_invendr_data");
        script.id = pageKey;
        script.async = true;
        if (typeof pageKey === "string" && document.querySelectorAll("#".concat(pageKey)).length < 1) {
            document.body.appendChild(script);
        }
    // on refresh update invendr
    // removeInvendrDom();
    }
};
var InvendrScript = function(props) {
    var invendrKey = props.invendrKey, pageKey = props.pageKey;
    if (true) {
        window.get_invendr_data = function(data) {
            window.invendrData = data;
        };
        loadInvender(invendrKey, pageKey);
    }
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        next_router__WEBPACK_IMPORTED_MODULE_1__.Router.events.on("routeChangeComplete", loadInvender);
        return function() {
            next_router__WEBPACK_IMPORTED_MODULE_1__.Router.events.off("routeChangeComplete", loadInvender);
        // removeInvendrDom();
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (InvendrScript);


/***/ }),

/***/ 31366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ laylout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/context/HeaderFooterContext.tsx
var HeaderFooterContext = __webpack_require__(2621);
// EXTERNAL MODULE: ./src/keys/enkeys.ts
var enkeys = __webpack_require__(38410);
// EXTERNAL MODULE: ./src/keys/Frkeys.ts
var Frkeys = __webpack_require__(30971);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/footer/index.tsx


var AboutSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6945).then(__webpack_require__.bind(__webpack_require__, 96945));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96945)
            ];
        }
    }
});
var CommunitySection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3270).then(__webpack_require__.bind(__webpack_require__, 53270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53270)
            ];
        }
    }
});
var CopyRightComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9238), __webpack_require__.e(3515)]).then(__webpack_require__.bind(__webpack_require__, 93515));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93515)
            ];
        }
    }
});
var CorporateSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5340).then(__webpack_require__.bind(__webpack_require__, 95340));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95340)
            ];
        }
    }
});
var SocialLinks = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7240).then(__webpack_require__.bind(__webpack_require__, 47240));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47240)
            ];
        }
    }
});
var TrustSection = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1588).then(__webpack_require__.bind(__webpack_require__, 81588));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81588)
            ];
        }
    }
});
var Footer = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "footer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sv-footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AboutSection, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustSection, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunitySection, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CorporateSection, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialLinks, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyRightComponent, {})
        ]
    });
};
/* harmony default export */ var footer = (Footer);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(61608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./public/images/logos/logo-depotium.svg
var logo_depotium = __webpack_require__(21766);
// EXTERNAL MODULE: ./src/services/home/setBrands.ts
var home_setBrands = __webpack_require__(76784);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(13135);
// EXTERNAL MODULE: ./src/components/header/Header.module.scss
var Header_module = __webpack_require__(89449);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Crop.js
var Crop = __webpack_require__(11048);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/OpenInNew.js
var OpenInNew = __webpack_require__(54048);
// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(19755);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/components/invendr-section/invendr.tsx
var invendr = __webpack_require__(18228);
// EXTERNAL MODULE: ./src/components/self-storage-moving/size-card.tsx + 2 modules
var size_card = __webpack_require__(5854);
;// CONCATENATED MODULE: ./public/images/icons/green-location-pin.svg
/* harmony default export */ var green_location_pin = ({"src":"/_next/static/media/green-location-pin.ab4e8053.svg","height":13,"width":11});
// EXTERNAL MODULE: ./src/components/header/right-panel-menu/my-account-modal.tsx + 1 modules
var my_account_modal = __webpack_require__(65100);
// EXTERNAL MODULE: ./src/components/header/mobile-header/mobile.module.scss
var mobile_module = __webpack_require__(97734);
var mobile_module_default = /*#__PURE__*/__webpack_require__.n(mobile_module);
;// CONCATENATED MODULE: ./src/components/header/mobile-header/index.tsx
















var MobileHeader = function(props) {
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var ref1 = (0,react.useState)(false), sizeModal = ref1[0], setSizeModal = ref1[1];
    var ref2 = (0,next_router.useRouter)(), locales = ref2.locales, asPath = ref2.asPath, locale = ref2.locale;
    var router = (0,next_router.useRouter)();
    var storageDropdownRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        jquery_default()(function() {
            jquery_default()(".close-menu").on("click", function() {
                if (jquery_default()(".navbar-toggler").css("display") !== "none") {
                    jquery_default()(".navbar-toggler").trigger("click");
                }
            });
        });
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(invendr/* default */.Z, {
                invendrKey: constants/* INVENDR_KEY_HOMEPAGE */.tW,
                pageKey: "mobile-header"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "navbar-toggler",
                        type: "button",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": "#navbarSupportedContent",
                        "aria-controls": "navbarSupportedContent",
                        "aria-expanded": "false",
                        "aria-label": "Toggle navigation",
                        onClick: props.handleExpand,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "nav-icon3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "overlay-for-menu",
                        style: props.showClass,
                        onClick: props.handleExpand
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "navbar-collapse sidenav",
                        id: "mobileNav",
                        style: props.heightStyle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "overlay-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                className: "navbar-nav",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "nav-item pt-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                            className: "nav-link close-menu d-flex",
                                            onClick: function() {
                                                return setSizeModal(true);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Crop/* default */.Z, {
                                                        className: "sv-size-guid-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "header.size-guide"
                                                })
                                            ]
                                        })
                                    }),
                                    sizeModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(size_card["default"], {
                                        open: sizeModal,
                                        onClose: function() {
                                            return setSizeModal(false);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "bg-dark sv-line"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "nav-item dropdown",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "nav-link dropdown-toggle storageDropdown",
                                                href: "#",
                                                id: "storageDropdown",
                                                role: "button",
                                                "data-bs-toggle": "dropdown",
                                                "aria-expanded": "false",
                                                ref: storageDropdownRef,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "header.self-storage"
                                                    }),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: "dropdown-menu dropdown-menu-end",
                                                "aria-labelledby": "storageDropdown",
                                                "data-bs-popper": "static",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/".concat(router.locale, "/self-storage"),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "dropdown-item close-menu",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "header.store-locator"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/".concat(router.locale, "/self-storage/residential"),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "dropdown-item close-menu",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "header.residential"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/".concat(router.locale, "/self-storage/car-storage"),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "dropdown-item close-menu",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "header.vehicles"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/".concat(router.locale, "/self-storage/student-storage"),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "dropdown-item close-menu",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "header.student-storage"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/".concat(router.locale, "/self-storage/business"),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "dropdown-item close-menu",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "header.business"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/".concat(router.locale, "/self-storage/moving"),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "dropdown-item close-menu",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "header.moving"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "bg-dark sv-line"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: "nav-item dropdown",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "nav-link dropdown-toggle",
                                                href: "#",
                                                id: "portableStorageDropdown",
                                                role: "button",
                                                "data-bs-toggle": "dropdown",
                                                "aria-expanded": "false",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "header.portable-storage"
                                                    }),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                className: "dropdown-menu dropdown-menu-end",
                                                "aria-labelledby": "portableStorageDropdown",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/".concat(router.locale, "/portable-storage/residential"),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "dropdown-item close-menu",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "header.residential"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/".concat(router.locale, "/portable-storage/business-storage"),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "dropdown-item close-menu",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "header.business"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/".concat(router.locale, "/portable-storage/moving"),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "dropdown-item close-menu",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "header.moving"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/".concat(router.locale, "/portable-storage/long-distance-moving"),
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "dropdown-item close-menu",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                                    id: "header.long-dist-moving"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "bg-dark sv-line"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "nav-item",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: constants/* PACKING_SUPPLIES_SHOP */.jJ,
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "nav-link close-menu",
                                                target: "_blank",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "header.packing-supplies"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInNew/* default */.Z, {
                                                        className: "sv-menu-shop-portal-icon"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "bg-dark sv-line"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "nav-item close-menu hidden-logo-xxs d-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/".concat(router.locale, "/self-storage"),
                                            prefetch: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                className: "nav-link location",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: green_location_pin,
                                                        alt: "location-pin",
                                                        className: "location-pin-img",
                                                        priority: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                        id: "header.find-storage"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "nav-item",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "nav-link close-menu",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                onClick: function() {
                                                    return setShowModal(true);
                                                },
                                                className: (mobile_module_default()).pointer,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                    id: "header.myaccount-makepayment"
                                                })
                                            })
                                        })
                                    }),
                                    showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(my_account_modal["default"], {
                                        open: showModal,
                                        onClose: function() {
                                            return setShowModal(false);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                        className: "bg-dark sv-line"
                                    }),
                                    (0,_to_consumable_array/* default */.Z)(locales).sort().map(function(llocale) {
                                        return locale !== llocale ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "nav-item close-menu",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "".concat(asPath),
                                                locale: llocale,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: "nav-link",
                                                    children: llocale === "en" ? "English" : "Fran\xe7ais"
                                                })
                                            })
                                        }, llocale) : "";
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var mobile_header = (MobileHeader);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AccountCircleOutlined.js
var AccountCircleOutlined = __webpack_require__(69436);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/LocalPhoneOutlined.js
var LocalPhoneOutlined = __webpack_require__(8987);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 10 modules
var Button = __webpack_require__(13850);
// EXTERNAL MODULE: ./src/components/smart-button/style.module.scss
var style_module = __webpack_require__(45492);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/smart-button/smart-button.tsx






var SmartButton = function(param) {
    var onClick = param.onClick, text = param.text, iconProps = param.iconProps, _hasIcon = param.hasIcon, hasIcon = _hasIcon === void 0 ? false : _hasIcon, href = param.href, textClassName = param.textClassName, Icon = param.Icon, dot = param.dot;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
        onClick: onClick,
        style: {
            backgroundColor: "#F2F2F2",
            color: "#1C1B1F",
            borderRadius: "8px",
            padding: "8px 16px",
            boxShadow: "none",
            minWidth: "20px",
            whiteSpace: "nowrap",
            fontFamily: "Hind",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "120%"
        },
        className: (style_module_default())["sv-smart-button"],
        sx: {
            "& .MuiButton-startIcon": {
                marginRight: "0px",
                marginLeft: "0px"
            }
        },
        variant: "contained",
        href: href,
        disableRipple: true,
        startIcon: hasIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, (0,_object_spread/* default */.Z)({}, iconProps)) : null,
        children: [
            text ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: textClassName,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: text
                })
            }) : null,
            dot && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (style_module_default()).filterDot
            })
        ]
    });
};
/* harmony default export */ var smart_button = (SmartButton);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/SearchOutlined.js
var SearchOutlined = __webpack_require__(58822);
// EXTERNAL MODULE: ./node_modules/react-places-autocomplete/dist/index.js
var dist = __webpack_require__(48837);
// EXTERNAL MODULE: ./src/context/MapCordinateContext.tsx
var MapCordinateContext = __webpack_require__(20546);
// EXTERNAL MODULE: ./src/utils/default.ts
var utils_default = __webpack_require__(84260);
// EXTERNAL MODULE: ./src/components/smart-textbox/style.module.scss
var smart_textbox_style_module = __webpack_require__(27034);
var smart_textbox_style_module_default = /*#__PURE__*/__webpack_require__.n(smart_textbox_style_module);
;// CONCATENATED MODULE: ./src/components/smart-textbox/smart-search-textbox.tsx















var SearchInput = function() {
    var ref = (0,next_router.useRouter)(), locale = ref.locale, push = ref.push;
    var ref1 = (0,react.useState)(""), address = ref1[0], setAddress = ref1[1];
    var ref2 = (0,react.useState)(false), isScrolled = ref2[0], setIsScrolled = ref2[1];
    var cords = (0,react.useContext)(MapCordinateContext/* default */.ZP);
    var searchOptions = {
        componentRestrictions: {
            country: [
                "ca"
            ]
        }
    };
    var handleChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setAddress(value);
                return [
                    2
                ];
            });
        });
        return function handleChange(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var performGeocode = function(inputAddress1) {
        var googleMapsGeocoder = new google.maps.Geocoder();
        var inputAddress = inputAddress1;
        googleMapsGeocoder.geocode({
            address: inputAddress,
            componentRestrictions: {
                country: "ca"
            }
        }, function(results) {
            if (results && results.length > 0) {
                (0,dist/* getLatLng */.WV)(results[0]).then(function(latLng) {
                    if (inputAddress.includes("#")) {
                        inputAddress = inputAddress.replace("#", "");
                    }
                    var finalLatLng = latLng !== null && latLng !== void 0 ? latLng : utils_default/* default.0.center */.Z[0].center;
                    var coords = finalLatLng;
                    cords.setLatLangs(coords);
                    cords === null || cords === void 0 ? void 0 : cords.setSisterInput(false);
                    push("/self-storage/?location=".concat(inputAddress, "&lat=").concat(coords.lat, "&lng=").concat(coords.lng));
                });
            }
        });
    };
    var handleClick = function(searchItem) {
        var inputAddress = searchItem && searchItem.length ? searchItem : address;
        performGeocode(inputAddress);
    };
    var handleSelect = function(value) {
        setAddress(value);
        cords.setAddresses(value);
        handleClick(value);
    };
    // Log error status and clear dropdown when Google Maps API returns an error.
    var onError = function(status, clearSuggestions) {
        console.error("Google Maps API returned error with status: ", status);
        clearSuggestions();
    };
    var handleScrolled = (0,react.useCallback)(function(e) {
        e.preventDefault();
        var scrollValue = Math.floor(window.scrollY);
        if (scrollValue > 295) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    }, [
        isScrolled
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", function(e) {
            return handleScrolled(e);
        });
        return function() {
            window.removeEventListener("scroll", function() {
                return handleScrolled;
            });
        };
    }, [
        isScrolled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((smart_textbox_style_module_default())["sv-smart-search-container"], " ").concat(isScrolled ? (smart_textbox_style_module_default()).scroll : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.ZP, {
            value: address,
            onChange: handleChange,
            onSelect: handleSelect,
            searchOptions: searchOptions,
            googleCallbackName: "initTwo",
            onError: onError,
            children: function(param) {
                var getInputProps = param.getInputProps, suggestions = param.suggestions, getSuggestionItemProps = param.getSuggestionItemProps, loading = param.loading;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (smart_textbox_style_module_default())["sv-smart-search"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
                            className: (smart_textbox_style_module_default())["sv-search-input"]
                        }, getInputProps({
                            disabled: false,
                            placeholder: locale === "en" ? constants/* SEARCH_PLACEHOLDER_EN */.l3 : constants/* SEARCH_PLACEHOLDER_FR */.nr
                        }))),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchOutlined/* default */.Z, {
                            className: (smart_textbox_style_module_default())["sv-search-icon"],
                            style: {
                                fontSize: "28px",
                                marginLeft: "unset",
                                cursor: "pointer"
                            },
                            onClick: function() {
                                return handleClick(address);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (smart_textbox_style_module_default())["sv-find-storage"],
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "header.find-storage"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (smart_textbox_style_module_default())["suggestions-dropdown"],
                            children: [
                                loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "...loading"
                                }) : null,
                                suggestions.map(function(suggestion, index) {
                                    var style = {
                                        backgroundColor: suggestion.active ? "#e9ecef" : "#fff"
                                    };
                                    return /*#__PURE__*/ (0,react.createElement)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        className: (smart_textbox_style_module_default()).options
                                    }, getSuggestionItemProps(suggestion, {
                                        style: style
                                    })), {
                                        key: index
                                    }), suggestion.description);
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};
/* harmony default export */ var smart_search_textbox = (SearchInput);

// EXTERNAL MODULE: ./src/components/header/right-panel-menu/right.module.scss
var right_module = __webpack_require__(53613);
var right_module_default = /*#__PURE__*/__webpack_require__.n(right_module);
;// CONCATENATED MODULE: ./src/components/header/right-panel-menu/index.tsx











var MyAccountModal = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 65100));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(65100)
            ];
        }
    }
});
var RightPanelMenu = function() {
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(false), showModal = ref4[0], setShowModal = ref4[1];
    var ref5 = (0,react.useState)(false), isCareersPage = ref5[0], setIsCareersPage = ref5[1];
    var router = (0,next_router.useRouter)();
    var locale = router.locale;
    var asPath = (0,next_router.useRouter)().asPath;
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var easternTime = new Date().toLocaleString("en-US", {
        timeZone: "America/New_York"
    });
    var hour = new Date(easternTime).getHours();
    var contactNumber = (ref = headerFooter[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.RC_Contact_Number;
    var timings = (ref2 = headerFooter[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.attributes) === null || ref3 === void 0 ? void 0 : ref3.Timings;
    var today = new Date().getDay();
    if (today === 0) today = 6;
    else today -= 1;
    var startTime = timings && timings[today].Start_Time;
    var endTime = timings && timings[today].End_Time;
    var openHours = "".concat(startTime, " ").concat(locale === "en" ? "to" : "\xe0", " ").concat(endTime, " ").concat(locale === "en" ? "ET" : ", HE");
    (0,react.useEffect)(function() {
        setIsCareersPage(router.asPath.includes("careers") || router.asPath.includes("carrieres"));
    }, [
        router
    ]);
    var isOpen = +hour >= 8 && +hour <= 21;
    var ContactInfo = function() {
        if (isOpen) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    id: "header.weAreOpen"
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                startTime,
                " ",
                locale === "en" ? " to" : "\xe0",
                " ",
                endTime,
                " ",
                locale === "en" ? "ET" : ", HE"
            ]
        });
    };
    var contactStyle = function() {
        if (hour >= 8 && hour <= 21) {
            return (right_module_default()).call;
        }
        return "".concat((right_module_default()).call, " ").concat((right_module_default()).call_gray);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "right-menu",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "navbar-nav flex-row justify-content-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: (right_module_default()).li,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(smart_search_textbox, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "".concat((right_module_default()).li, " ").concat((right_module_default())["my-account-btn"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(smart_button, {
                            onClick: function() {
                                return setShowModal(true);
                            },
                            text: "header.myaccount-makepayment",
                            textClassName: (right_module_default())["my-account"],
                            iconProps: {
                                style: {
                                    fontSize: "28px",
                                    maxWidth: "28px",
                                    maxHeight: "28px"
                                }
                            },
                            hasIcon: true,
                            Icon: AccountCircleOutlined/* default */.Z
                        })
                    }),
                    showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(MyAccountModal, {
                        open: showModal,
                        onClose: function() {
                            return setShowModal(false);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "".concat((right_module_default()).li, " ").concat((right_module_default())["sv-language-btn"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(smart_button, {
                            href: locale === "en" ? "/fr".concat(asPath) : "/en".concat(asPath),
                            text: locale === "en" ? "FR" : "EN"
                        })
                    }),
                    !isCareersPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        className: "".concat((right_module_default()).li, " nav-item"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (right_module_default())["sv-header-phone"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: contactStyle(),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalPhoneOutlined/* default */.Z, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactInfo, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "".concat((right_module_default())["sv-contact-number"], " nav-link pt-0 ps-0 text-center headerPhone"),
                                            href: "tel:".concat(contactNumber),
                                            "data-toggle": "tooltip",
                                            "data-placement": "top",
                                            title: openHours,
                                            children: contactNumber
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (right_module_default())["sv-header-phone-btn"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(smart_button, {
                                    href: "tel:".concat(contactNumber),
                                    hasIcon: true,
                                    Icon: LocalPhoneOutlined/* default */.Z,
                                    text: "",
                                    dot: isOpen
                                })
                            })
                        ]
                    }),
                    isCareersPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "".concat((right_module_default()).li, " nav-item"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "d-flex align-items-center h-100 dp-primary-header-btn",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://careers.storagevaultcanada.com/",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    type: "button",
                                    className: "btn dp-primary-btn dp-primary-header-btn ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "careers-header-apply"
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var right_panel_menu = (RightPanelMenu);

;// CONCATENATED MODULE: ./src/components/header/index.tsx














var Header = function() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14;
    var locale = (0,next_router.useRouter)().locale;
    var headerFooterData = (0,react.useContext)(HeaderFooterContext/* default */.ZP);
    var headerFooter = headerFooterData.headerFooter;
    var ref15 = (0,react.useState)(false), isScrolled = ref15[0], setIsScrolled = ref15[1];
    var isContext = !!headerFooter[0];
    var ref16 = (0,react.useState)([]), brands = ref16[0], setBrands = ref16[1];
    var getContextData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var defaultBrand, contextData;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        defaultBrand = constants/* BRAND_NAME_EN */.Vp;
                        if (locale === "fr") defaultBrand = constants/* BRAND_NAME_FR */.Fj;
                        return [
                            4,
                            (0,home_setBrands/* default */.Z)(defaultBrand, locale)
                        ];
                    case 1:
                        contextData = _state.sent();
                        setBrands(contextData === null || contextData === void 0 ? void 0 : contextData.data);
                        return [
                            2
                        ];
                }
            });
        });
        return function getContextData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        getContextData();
    }, [
        isContext,
        locale
    ]);
    var ref17 = (0,react.useState)(false), expa = ref17[0], setExpa = ref17[1];
    var ref18 = (0,react.useState)({
        display: "none"
    }), showClass = ref18[0], setShowClass = ref18[1];
    var ref19 = (0,react.useState)(false), height = ref19[0], setHeight = ref19[1];
    var ref20 = (0,react.useState)({
        height: "0"
    }), heightStyle = ref20[0], setHeightStyle = ref20[1];
    var handleExpand = function() {
        setExpa(!expa);
        if (expa) {
            setShowClass({
                display: "none"
            });
            document.getElementById("nav-icon3").classList.remove("open");
        } else {
            setShowClass({
                display: "block"
            });
            setTimeout(function() {
                document.getElementById("storageDropdown").click();
            }, 100);
            document.getElementById("nav-icon3").classList.add("open");
        }
        setHeight(!height);
        if (height) setHeightStyle({
            height: "0"
        });
        else setHeightStyle({
            height: "600px"
        });
    };
    var handleCLose = function() {
        setExpa(false);
        setShowClass({
            display: "none"
        });
        setHeight(false);
        setHeightStyle({
            height: "0"
        });
        document.getElementById("nav-icon3").classList.remove("open");
    };
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            setIsScrolled(window.scrollY > 0);
        };
        // Attach the event listener
        window.addEventListener("scroll", handleScroll);
        // Clean up the event listener on component unmount
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "".concat((Header_module_default())["sv-navbar"], " navbar sv-header ").concat(isScrolled ? "sv-header-shadow" : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container-xl custom-container px-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "nav-section",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "leftSide-nav",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_header, {
                                        showClass: showClass,
                                        heightStyle: heightStyle,
                                        handleExpand: handleExpand
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "navbar-brand",
                                            onClick: handleCLose,
                                            children: (brands === null || brands === void 0 ? void 0 : brands.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: (ref = brands[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Logo) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.attributes) === null || ref4 === void 0 ? void 0 : ref4.url,
                                                alt: "logo",
                                                width: "130",
                                                height: "60",
                                                priority: true
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: logo_depotium/* default */.Z,
                                                alt: "logo",
                                                width: "130",
                                                height: "60",
                                                priority: true
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "navbar-brand",
                                        onClick: handleCLose,
                                        children: ((ref5 = brands[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.attributes) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.secondary_logo) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.data) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.attributes) === null || ref9 === void 0 ? void 0 : ref9.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (ref10 = brands[0]) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.attributes) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.secondary_logo) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.data) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.attributes) === null || ref14 === void 0 ? void 0 : ref14.url,
                                            alt: "secondary-logo",
                                            width: "130",
                                            height: "60",
                                            priority: true
                                        }) : null
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "rightSide-nav",
                                onClick: handleCLose,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(right_panel_menu, {})
                            })
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var header = (Header);

;// CONCATENATED MODULE: ./src/components/laylout/index.tsx









var Layout = function(param) {
    var children = param.children;
    var ref = (0,next_router.useRouter)(), locale = ref.locale, pathname = ref.pathname;
    var ref1 = (0,react.useState)(true), isMounted = ref1[0], setMount = ref1[1];
    var ref2 = (0,react.useContext)(HeaderFooterContext/* default */.ZP), isShowHeaderFooter = ref2.isShowHeaderFooter, isShowSelfHeader = ref2.isShowSelfHeader;
    var router = (0,next_router.useRouter)();
    var urlPath = router === null || router === void 0 ? void 0 : router.asPath.split("/");
    /* eslint-disable no-param-reassign */ var generateFrPath = function() {
        var frPath = "";
        urlPath.forEach(function(el) {
            if (el && el !== "en") {
                frPath += "/";
                el = Frkeys/* default */.Z[el] === undefined ? el : Frkeys/* default */.Z[el];
                frPath += el;
            }
        });
        return frPath;
    };
    var generateEnPath = function() {
        var enPath = "";
        urlPath.forEach(function(el) {
            if (el && el !== "fr") {
                enPath += "/";
                el = enkeys/* default */.Z[el] === undefined ? el : enkeys/* default */.Z[el];
                enPath += el;
            }
        });
        return enPath;
    };
    (0,react.useEffect)(function() {
        setMount(true);
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        href: "".concat("https://www.depotium.com", "/en").concat(generateEnPath(), "/"),
                        hrefLang: "en"
                    }, "en"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "alternate",
                        href: "".concat("https://www.depotium.com", "/fr").concat(generateFrPath(), "/"),
                        hrefLang: "fr"
                    }, "fr")
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: pathname === "/" || pathname === "/self-storage/residential" || pathname === "/self-storage/moving" || pathname === "/self-storage/business" || pathname === "/self-storage/car-storage" || pathname === "/self-storage/student-storage" || pathname === "/self-storage/climate-controlled-storage" || pathname === "/self-storage/boat-storage" || pathname === "/self-storage/motorcycle-storage" || pathname === "/self-storage/recretional-storage" || pathname === "/self-storage/rv-storage" || pathname === "/self-storage/truck-storage" || pathname === "/self-storage/emergency-storage" ? "layout sv-wrapper ".concat(locale === "fr" ? "french-language" : "") : "layout sv-wrapper sticky_navigation ".concat(locale === "fr" ? "french-language" : ""),
                children: [
                    isShowSelfHeader && /*#__PURE__*/ (0,jsx_runtime.jsx)(header, {}),
                    isMounted ? children : null
                ]
            }),
            isShowHeaderFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
        ]
    });
};
/* harmony default export */ var laylout = (Layout);


/***/ }),

/***/ 76784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66156);



var SetBrandsContext = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var brand, locale, ref, result, data;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    brand = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "dp", locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en";
                    return [
                        4,
                        Promise.all([
                            (0,___WEBPACK_IMPORTED_MODULE_0__/* .getHeaderAndFooterDetailsWithDefaultLocale */ .YW)(brand, locale)
                        ])
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        4,
                        (ref = result[0]) === null || ref === void 0 ? void 0 : ref.data
                    ];
                case 2:
                    data = _state.sent() || null;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function SetBrandsContext() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (SetBrandsContext);


/***/ }),

/***/ 42169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getAllProvincesData; }
/* harmony export */ });
/* unused harmony export getStoreData */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var _utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15122);
/* harmony import */ var _apiUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33891);




var getAllProvincesData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var locale, brand;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            locale = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : "en", brand = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "dp";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getAllProvinces */ .lv(locale, brand)), "get")
            ];
        });
    });
    return function getAllProvincesData() {
        return _ref.apply(this, arguments);
    };
}();
var getStoreData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(province) {
        var locale, brand;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            locale = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : "en", brand = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "dp";
            return [
                2,
                (0,_utils_request__WEBPACK_IMPORTED_MODULE_0__/* .doRequest */ .NE)("".concat(_apiUrl__WEBPACK_IMPORTED_MODULE_1__/* .getProviStore */ .qY(province, locale, brand)), "get")
            ];
        });
    });
    return function getStoreData(province) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 84260:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var defaultCenters = [
    {
        brand: "as",
        center: {
            lat: 43.7615714,
            lng: -79.2921276
        }
    },
    {
        brand: "dp",
        center: {
            lat: 45.4965782,
            lng: -73.5591249
        }
    },
    {
        brand: "se",
        center: {
            lat: 51.0553635,
            lng: -114.0186927
        }
    }, 
];
/* harmony default export */ __webpack_exports__["Z"] = (defaultCenters);


/***/ }),

/***/ 89449:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sv-navbar":"Header_sv-navbar__bELo_"};

/***/ }),

/***/ 97734:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pointer":"mobile_pointer__MC8Yv"};

/***/ }),

/***/ 53613:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"arrange":"right_arrange__e058Y","li":"right_li__HlfTK","call":"right_call__MNjQs","call_gray":"right_call_gray__AS5_U","pointer":"right_pointer__OdNb5","my-account":"right_my-account__1rtxX","sv-header-phone-btn":"right_sv-header-phone-btn__8DdZL","sv-contact-number":"right_sv-contact-number__rLojQ","my-account-btn":"right_my-account-btn__bGUEJ","sv-language-btn":"right_sv-language-btn__9wikD","sv-header-phone":"right_sv-header-phone__VPtzq"};

/***/ }),

/***/ 45492:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sv-smart-button":"style_sv-smart-button__0V4sA","filterDot":"style_filterDot__6yKgm","changeBackground":"style_changeBackground__pbkPR"};

/***/ }),

/***/ 27034:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"suggestions-dropdown":"style_suggestions-dropdown__3CaiN","options":"style_options__426Fx","sv-smart-search-container":"style_sv-smart-search-container__dEIBN","sv-smart-search":"style_sv-smart-search__7OD11","sv-search-input":"style_sv-search-input__SCS4P","sv-find-storage":"style_sv-find-storage__y48ut","sv-search-icon":"style_sv-search-icon__PiiR5","scroll":"style_scroll___yHSj"};

/***/ }),

/***/ 76792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SC": function() { return /* binding */ useIsRTL; },
/* harmony export */   "vE": function() { return /* binding */ useBootstrapPrefix; }
/* harmony export */ });
/* unused harmony exports DEFAULT_BREAKPOINTS, DEFAULT_MIN_BREAKPOINT, useBootstrapBreakpoints, useBootstrapMinBreakpoint, createBootstrapComponent, ThemeConsumer */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
"use client";




const DEFAULT_BREAKPOINTS = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
const DEFAULT_MIN_BREAKPOINT = 'xs';
const ThemeContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  prefixes: {},
  breakpoints: DEFAULT_BREAKPOINTS,
  minBreakpoint: DEFAULT_MIN_BREAKPOINT
});
const {
  Consumer,
  Provider
} = ThemeContext;
function ThemeProvider({
  prefixes = {},
  breakpoints = DEFAULT_BREAKPOINTS,
  minBreakpoint = DEFAULT_MIN_BREAKPOINT,
  dir,
  children
}) {
  const contextValue = useMemo(() => ({
    prefixes: {
      ...prefixes
    },
    breakpoints,
    minBreakpoint,
    dir
  }), [prefixes, breakpoints, minBreakpoint, dir]);
  return /*#__PURE__*/_jsx(Provider, {
    value: contextValue,
    children: children
  });
}
function useBootstrapPrefix(prefix, defaultPrefix) {
  const {
    prefixes
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function useBootstrapBreakpoints() {
  const {
    breakpoints
  } = useContext(ThemeContext);
  return breakpoints;
}
function useBootstrapMinBreakpoint() {
  const {
    minBreakpoint
  } = useContext(ThemeContext);
  return minBreakpoint;
}
function useIsRTL() {
  const {
    dir
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ThemeContext);
  return dir === 'rtl';
}
function createBootstrapComponent(Component, opts) {
  if (typeof opts === 'string') opts = {
    prefix: opts
  };
  const isClassy = Component.prototype && Component.prototype.isReactComponent;
  // If it's a functional component make sure we don't break it with a ref
  const {
    prefix,
    forwardRefAs = isClassy ? 'ref' : 'innerRef'
  } = opts;
  const Wrapped = /*#__PURE__*/React.forwardRef(({
    ...props
  }, ref) => {
    props[forwardRefAs] = ref;
    const bsPrefix = useBootstrapPrefix(props.bsPrefix, prefix);
    return /*#__PURE__*/_jsx(Component, {
      ...props,
      bsPrefix: bsPrefix
    });
  });
  Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
  return Wrapped;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (ThemeProvider)));

/***/ }),

/***/ 93967:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

}]);